/** True for Safari and Apple WebKit shells (e.g. macOS desktop WKWebView), not Chrome/Edge/Firefox/Electron. */
export function isSafariWebKit(): boolean {
    if (typeof window !== 'undefined' && (window as { safari?: unknown }).safari) {
        return true;
    }

    if (typeof navigator === 'undefined') {
        return false;
    }

    const ua = navigator.userAgent;
    const vendor = navigator.vendor || '';
    const isChromiumFamily = /Chrome|CriOS|Chromium|Edg|OPR|Firefox|FxiOS/i.test(
        ua
    );

    if (isChromiumFamily) {
        return false;
    }

    return (
        (/Safari/i.test(ua) && /Apple/i.test(vendor)) ||
        (/AppleWebKit/i.test(ua) && /Apple/i.test(vendor))
    );
}

export function applySafariLayoutFixClass(): void {
    if (typeof document === 'undefined' || !isSafariWebKit()) {
        return;
    }

    document.documentElement.classList.add('safari-layout-fix');
}
